import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

export default class deliverydashboardservice {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getDeliveryTypeList() {
    const deliveryTypeAPI = new API({
      url: this.config.DROPDOWN_URL,
    });
    deliveryTypeAPI.createEntity({
      name: this.endpoint.GET_DELIVERY_TYPES,
    });
    let deliveryTypes = [];
    await deliveryTypeAPI.endpoints[this.endpoint.GET_DELIVERY_TYPES]
      .getAll()
      .then((response) => {
        deliveryTypes = response.data;
      })
      .catch((err) => {
        deliveryTypes = this.common.handleError(err);
      });
    if (deliveryTypes.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        deliveryTypes = this.getDeliveryTypeList();
      });
    }
    return Promise.resolve(deliveryTypes);
  }

  async retrieveItems(param) {
    console.log("param->",param);
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.GET_DELIVERY_MANAGEMENT });
    let itemArray = [];
    await myApi.endpoints.GetDeliveryManagmnet.getAllPost(param)
      .then(({ data }) => {
        itemArray = data;
      })
      .catch((err) => {
        itemArray = this.common.handleError(err)
      });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.retrieveItems(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  async getDeliveryDatafromSplitOrderStatus(param) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.GET_DELIVERYDATA_FROM_SPLITORDERSTATUS });
    let itemArray = [];
    await myApi.endpoints.GetDeliveryDataFromSplitOrderStatus.getAllPost(param)
      .then(({ data }) => {
        itemArray = data;
      })
      .catch((err) => {
        itemArray = this.common.handleError(err)
      });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.getDeliveryDatafromSplitOrderStatus(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  async getDeliveryAttention(param) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.GET_DELIVERY_ATTENTION });
    let itemArray = [];
    await myApi.endpoints.GetDeliveryAttention.getAllPost(param)
      .then(({ data }) => { itemArray = data; })
      .catch((err) => { itemArray = this.common.handleError(err); });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.getDeliveryAttention(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  async getDeliveryOverdueList(param) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.GET_DELIVERY_OVERDUE_LIST });
    let itemArray = [];
    await myApi.endpoints.GetDeliveryOverdueList.getAllPost(param)
      .then(({ data }) => { itemArray = data; })
      .catch((err) => { itemArray = this.common.handleError(err); });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.getDeliveryOverdueList(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  async getDeliveryStageAging(param) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.GET_DELIVERY_STAGE_AGING });
    let itemArray = [];
    await myApi.endpoints.GetDeliveryStageAging.getAllPost(param)
      .then(({ data }) => { itemArray = data; })
      .catch((err) => { itemArray = this.common.handleError(err); });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.getDeliveryStageAging(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  async getDeliveryDispatchSLA(param) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.GET_DELIVERY_DISPATCH_SLA });
    let itemArray = [];
    await myApi.endpoints.GetDeliveryDispatchSLA.getAllPost(param)
      .then(({ data }) => { itemArray = data; })
      .catch((err) => { itemArray = this.common.handleError(err); });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.getDeliveryDispatchSLA(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  async getTATRiskSummary(param) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.GET_TAT_RISK_SUMMARY });
    let itemArray = [];
    await myApi.endpoints.GetTATRiskSummary.getAllPost(param)
      .then(({ data }) => { itemArray = data; })
      .catch((err) => { itemArray = this.common.handleError(err); });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.getTATRiskSummary(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  async getTATRiskList(param) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.GET_TAT_RISK_LIST });
    let itemArray = [];
    await myApi.endpoints.GetTATRiskList.getAllPost(param)
      .then(({ data }) => { itemArray = data; })
      .catch((err) => { itemArray = this.common.handleError(err); });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.getTATRiskList(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  async saveTATRiskAck(param) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.SAVE_TAT_RISK_ACK });
    let itemArray = [];
    await myApi.endpoints.SaveTATRiskAck.getAllPost(param)
      .then(({ data }) => { itemArray = data; })
      .catch((err) => { itemArray = this.common.handleError(err); });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.saveTATRiskAck(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  async getTATConfig(param) {
    const myApi = new API({ url: this.config.ITEM_STORE_URL });
    myApi.createEntity({ name: this.endpoint.GET_TAT_CONFIG });
    let itemArray = [];
    await myApi.endpoints.GetTATConfig.getAllPost(param || {})
      .then(({ data }) => { itemArray = data; })
      .catch((err) => { itemArray = this.common.handleError(err); });
    if (itemArray.statusCode == 401) {
      await this.common.refreshToken().then((response) => {
        this.common.setToken(response);
        itemArray = this.getTATConfig(param);
      });
    }
    return Promise.resolve(itemArray);
  }

  handleResponseError(response) {
    throw new Error("HTTP error, status = " + response.status);
  }
}
